document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);

    const product = params.get('product');
    const collection = params.get('collection');
    const handle = params.get('handle');

    const observer = new MutationObserver(() => {
        // Find the message textarea
        const messageField = document.querySelector('textarea[name="textarea"]');

        // Find the form containing it
        const form = messageField ? messageField.closest('form') : null;

        if (!messageField || !form) {
            return;
        }

        // Stop observing once the form is found
        observer.disconnect();

        // Populate message
        if (product && collection) {
            messageField.value = `I would like to inquire about the product "${product}" from the collection "${collection}".`;

            // Trigger input event in case Globo listens for changes
            messageField.dispatchEvent(new Event('input', { bubbles: true }));
            messageField.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (!handle) {
            return;
        }

        fetch(`/products/${handle}.js`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch product (${response.status})`);
                }
                return response.json();
            })
            .then(productData => {
                const addHiddenInput = (name, value) => {
                    if (!value) return;

                    let input = form.querySelector(`input[name="${name}"]`);

                    if (!input) {
                        input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = name;
                        form.appendChild(input);
                    }

                    input.value = value;
                };

                addHiddenInput('hidden-1', productData.title);
                addHiddenInput('hidden-2', handle);
                addHiddenInput('hidden-3', collection);
                addHiddenInput('hidden-4', productData.variants?.[0]?.sku);

                const image = productData.images?.[0];
                if (image) {
                    addHiddenInput(
                        'hidden-5',
                        image.startsWith('//') ? `https:${image}` : image
                    );
                }
            })
            .catch(error => {
                console.error('Product fetch error:', error);
            });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});